
<label [for]="name">{{label}}</label>

<div class="image-container" [ngClass]="{'has-content': inputModel}">

    <div class="placeholder" *ngIf="!inputModel">
        <span>Foto hochladen</span>
    </div>
    <div class="button clear-button" *ngIf="inputModel">
        <i class="juc ju-delete" (click)="onRemoveBtnClicked()"></i>
    </div>
    <div class="button refresh-button" *ngIf="inputModel">
        <img src="./assets/images/icons/refresh.svg">
    </div>

    <img #htmlImageElement [ngClass]="{'hidden':!inputModel}">
    <input class="custom-file-input" type="file" [ngClass]="{'small':inputModel}"
           [id]="name" #imageUploader
           accept="image/jpg, image/jpeg, image/png"
           (click)="imageUploader.value = null; disableFocusOutTesting(focusTest)"
           (change)="processFile(htmlImageElement, $event)">
    <input class="validation-helper" type="text"
           [name]="name + 'name'"
           required
           [(ngModel)]="inputModel">

    <div #focusTest (focusout)="onFocusOut()" tabindex="-1" ></div>
</div>
